/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */
import zhLocale from "element-ui/lib/locale/lang/zh-CN";

const cn = {
  routeName: {
    home: "主页",
    article: "文章管理",
    publishArticle: "发表文章",
    publishArticleEditor: "发表文章-富文本",
    user: "用户",
    userList: "用户列表",
    icon: "图标",
    builtInIcon: "内置图标",
    shuttleBox: "穿梭框",
    demoShuttle: "穿梭框demo",
    permissions: "权限管理",
    pageControl: "页面权限",
    btnControl: "按钮权限",
    table: "表格",
    multiDataTable: "多选数据表格",
    filterTable: "筛选表格",
    dragSort: "拖拽排序",
    upload: "上传",
    fileUpload: "文件上传",
    editor: "编辑器",
    markdown: "markdown",
    wangeditor: "wangeditor",
    multiDirectory: "多级目录",
    "menu2-1": "二级-1",
    "menu2-2": "二级-2",
    "menu2-3": "二级-3",
    "menu3-1": "三级-1",
    "menu3-2": "三级-2",
    "menu3-3": "三级-3",
    "menu4-1": "四级-1",
    "menu4-2": "四级-2",
    "menu5-1": "五级-1",
    enterpriseManage: "企业管理",
    sysCompany: "公司管理",
    storeManage: "门店管理",
    instetusionManage: "门店管理",
    authoritySysUser: "用户管理",
    roleManage: "角色管理",
    sysRoleList: "用户角色审批",
    sysRoleForm: "用户角色申请",
    companyAdmin: "公司管理员管理",
    sysUser: "门店管理员管理",
    systemManage: "系统管理",
    functionalManage: "功能管理",
    buttonManage: "按钮管理",
    CRMORDER: "CRM订单管理",
    productManagement: "产品管理",
    orderManagement: "订单查询",
    waveManagement: "波次管理",
    returnManagement: "退货管理",
    shippingTemplate: "发货管理",
    basicConfiguration: "基础配置",
    crmDeptConfiguration: "CRM部门配置",
    expressBusinessType: "快递业务类型",
    expressNumSet: '顺丰月结账号设置',
    ProductIssueQuery: '产品出库管理',
    ProductIssue: '产品出库查询',
    retryList: '管易异常数据重试',
    gyOrderList: '管易订单列表',
    guanyiOrder: '管易订单列表',
    newGuanyiOrder:'管易订单列表',
    InvoiceOrder:'发货单',
    returnGoods:'退货单'
  },
  rightMenu: {
    close: "关闭",
    closeOther: "关闭其他",
    closeAll: "全部关闭"
  },
  role: {
    superAdmin: "超级管理员",
    admin: "管理员",
    ordinary: "普通用户"
  },
  userDropdownMenu: {
    basicInfor: "基本资料",
    changePassword: "修改密码",
    logout: "退出"
  },
  ...zhLocale //  合并element-ui内置翻译
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js